import { render, staticRenderFns } from "./ReserveFlow.vue?vue&type=template&id=086b7b52"
import script from "./ReserveFlow.vue?vue&type=script&lang=ts"
export * from "./ReserveFlow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports